import {
  Alert, Box, Button, Grid, IconButton, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography,
  useTheme,
} from '@mui/material';
import { Trash01, Plus } from '../../../assets';
import { useContext } from 'react';
import { ScheduleCreateContext, ScheduleCreateValues } from '../contexts/ScheduleCreateContext';


const ScheduleCreateCountZoneTypes = () => {
  const { t,
    isLoading,
    isCountZoneConfigEnabled,
    countZoneTypesData,
    hasRightToEdit,
    deleteCountZoneTypeRow,
    handleAddCountZoneTypesClick } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  const theme = useTheme();
  const sortedCountZoneTypes = [...countZoneTypesData].sort((a, b) => 
    (a.name || '').localeCompare(b.name || ''),
  );
  const hasCountZoneTypes = sortedCountZoneTypes.length > 0;

  if (isLoading || !isCountZoneConfigEnabled) {
    return <></>;
  }

  return (
    <Box sx={{ border: '2px solid', borderRadius: '4px', borderColor: theme.palette.primary[500] }}>
      <Grid container
        sx={{ pt: '12px', pb: '6px', px: '8px' }}>
        <Grid item
          xs={3}>
          <Typography variant="textMD"
            sx={{ fontWeight: 'bold' }}>{t('countZoneTypes.title')}</Typography>
        </Grid>
        <Grid item
          xs={9}
          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          {hasCountZoneTypes && (
            <Button
              size='lg'
              sx={{ mr: 4 }}
              variant='bad'
              disabled={!hasRightToEdit}
              onClick={() => deleteCountZoneTypeRow()}>
              <Trash01 />{t('deleteAll')}
            </Button>
          )}
          <Button
            size='lg'
            variant='primary'
            disabled={!hasRightToEdit}
            onClick={handleAddCountZoneTypesClick}><Plus />{t('add')}
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ pt: '10px' }}>
        {hasCountZoneTypes ? (
          <TableContainer sx={{ overflowy: 'auto' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('countZoneTypes.subtitle')}
                  </TableCell>
                  <TableCell
                    style={{ display: 'flex', justifyContent: 'flex-end' }} >{t('remove')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedCountZoneTypes?.map((row) => (
                  <TableRow key={row.countZoneTypeId}>
                    <TableCell>
                      <Typography variant='textXS'
                        fontWeight={600}>
                        {row.name}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ display: 'flex', justifyContent: 'flex-end' }} >
                      <IconButton
                        disabled={!hasRightToEdit}
                        onClick={() => { deleteCountZoneTypeRow(row.countZoneTypeId); }}>
                        <Trash01 style={{ color: !hasRightToEdit ? 'action' : 'red' }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Alert severity='info'
            variant='outlined'
            sx={{ mb: '12px', mx: '8px' }}>
            {t('countZoneTypes.noTypes')}
          </Alert>
        )}
      </Box>
    </Box>
  );
};

export default ScheduleCreateCountZoneTypes;
